import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import onboarding_layer_one from "../../assets/images/onboardingSteponeBackground.png";
import onboarding_layer_two from "../../assets/images/onboardingSteponelogo.png";
import onboarding_step_two_layer_one from "../../assets/images/onboardingSteptwoLayerOne.png";
import onboarding_step_two_layer_two from "../../assets/images/onboardingSteptwoLayerTwo.png";
import onboarding_step_two_layer_three from "../../assets/images/onboardingSteptwoLayerThree.png";
import onboarding_step_three_layer_one from "../../assets/images/onboardingStepthreeLayerOne.png";
import onboarding_step_three_layer_two from "../../assets/images/onboardingStepthreeLayerTwo.png";
import onboarding_step_three_layer_three from "../../assets/images/onboardingStepthreeLayerThree.png";
import Toaster from "../../components/ui/toaster";

const ONBOARDING_STEPS = [
  {
    title: "One app, limitless possibilities.",
    description:
      "The combined power of traditional and digital finance in one smart, borderless wallet.",
    descriptionClass: "lg:px-20 px-10",
  },
  {
    title: "Own. Move. Grow.",
    description:
      "Own your digital assets, move money across borders, and grow your wealth in a connected ecosystem where traditional and digital finance meet.",
    descriptionClass: "lg:px-0 px-12",
  },
  {
    title: "Crypto Solutions",
    description:
      "We have transparent fees, better rates, and cutting-edge digital solutions for your every need.",
    descriptionClass: "lg:px-0 px-12",
  },
];

const WelcomeBanner = () => (
  <div className="max-w-[300px] rounded-full px-4 module-border-wrap-onboarding">
    <div className="module !bg-black">
      <h2 className="lg:text-[17.44px] text-[14px] leading-[140%] tracking-[-0.02em] font-normal font-DMMono text-white/70 py-[5px] px-[15px]">
        Welcome to 80eight
      </h2>
    </div>
  </div>
);

export default function SignIn() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const currentStep = ONBOARDING_STEPS[step - 1];

  const nextStep = () => {
    if (step < 3) setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep((prev) => prev - 1);
  };

  const login = async () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen text-gray-900 transition-colors dark:text-gray-100">
      <div className="flex flex-col w-full h-screen bg-black">
        <div className="flex flex-col items-center justify-center mx-auto lg:mb-[40px] h-full w-full max-w-[1000px] text-center z-[100]">
          <div className="relative flex justify-center items-center w-full overflow-hidden">
            {step === 1 && (
              <div className="lg:mb-5 mb-[40px] lg:h-[252px] h-[203px] max-w-[260px] lg:max-w-[308px] relative">
                <div className="relative top-[-20px] z-[10]">
                  <img
                    src={onboarding_layer_one}
                    alt="Background layer"
                    className="lg:scale-[1.4] scale-[1.6] pulse-brightness"
                  />
                </div>
                <div className="absolute top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[20]">
                  <img
                    src={onboarding_layer_two}
                    alt="Logo layer"
                    className="!w-[124px] !h-[127px]"
                  />
                </div>
              </div>
            )}
            {step === 2 && (
              <div className="lg:mb-5 mb-[40px] lg:h-[252px] h-[203px] relative overflow-hidden flex items-start justify-center w-full">
                <img
                  src={onboarding_step_two_layer_one}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] rotate-spin absolute"
                />
                <img
                  src={onboarding_step_two_layer_two}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] pulse-brightness-rotate-spin absolute"
                />
                <img
                  src={onboarding_step_two_layer_three}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] rotate-spin absolute"
                />
                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0)_85%,rgba(0,0,0,0.9)_100%)]"></div>
              </div>
            )}
            {step === 3 && (
              <div className="lg:mb-5 mb-[40px] lg:h-[252px] h-[203px] relative overflow-hidden flex items-start justify-center w-full">
                <img
                  src={onboarding_step_three_layer_one}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] pulse-brightness absolute"
                />
                <img
                  src={onboarding_step_three_layer_two}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] absolute zoom-in-out"
                />
                <img
                  src={onboarding_step_three_layer_three}
                  alt="Onboarding Step 2"
                  className="lg:max-w-[600px] max-w-[500px] absolute diagonal-move"
                />
                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.9)_1%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,rgba(0,0,0,0.9)_100%)]"></div>
              </div>
            )}
          </div>
          <WelcomeBanner />
          <div>
            <div>
              <h2 className="bg-[linear-gradient(273.9deg,#EB3366_18.84%,#57249C_31.98%,#00FFFF_45.13%,rgba(255,255,255,0.92)_65.02%,rgba(255,255,255,0.3)_89.89%)] bg-clip-text text-transparent font-plusjakarta font-semibold text-[48px] tracking-[-0.02em] lg:px-0 px-10 text-center align-middle lg:leading-[140%] leading-[100%] mt-5">
                {currentStep.title}
              </h2>
            </div>

            <div className="lg:mt-4 mt-2">
              <p
                className={`font-plusjakarta lg:max-w-[550px] mx-auto font-light text-[16px] leading-[140%] tracking-[-0.02em] text-center align-middle text-white/60 ${currentStep.descriptionClass}`}
              >
                {currentStep.description}
              </p>
            </div>
          </div>

          <div className="lg:mt-8 mt-5 flex justify-center items-center w-full gap-4">
            {step > 1 && (
              <button
                className="lg:w-[150px] w-[95px] bg-transparent text-white !rounded-full font-plusjakarta font-medium text-[16.45px] leading-[23.5px] tracking-normal transition duration-300 ease-in-out hover:text-gray-400"
                onClick={prevStep}
                aria-label="Previous step"
              >
                Previous
              </button>
            )}

            {step < 3 ? (
              <button
                className="lg:w-[150px] w-[95px] bg-white !rounded-full font-plusjakarta font-medium text-[16.45px] leading-[23.5px] tracking-normal py-[12.5px] transition duration-300 ease-in-out hover:bg-gray-300"
                onClick={nextStep}
                aria-label="Next step"
              >
                Next
              </button>
            ) : (
              <button
                className="w-[196px] text-white !rounded-full font-plusjakarta font-medium text-[16.45px] leading-[23.5px] tracking-normal py-[12.5px] bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] transition duration-300 ease-in-out hover:brightness-125"
                onClick={login}
                aria-label="Login to 80eight"
              >
                Make money moves
              </button>
            )}
          </div>
        </div>

        <div className="relative lg:bottom-[10%] bottom-[4%] w-full">
          <div className="flex justify-center items-center mt-10 w-full">
            <button
              onClick={login}
              className="font-plusjakarta font-medium text-white !w-[150px] text-[16.45px] leading-[23.5px] tracking-normal transition duration-300 ease-in-out hover:text-gray-300 hover:scale-105 z-[100]"
              aria-label="Skip onboarding and login"
            >
              Skip to login &gt;
            </button>
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
}
